export enum ImagePath {
    LANDING = 'landing',
    USERS = 'users',
    ECOMMERCE = 'e-commerce',
    PROFILE = 'profile'
}

// ==============================|| NEW URL - GET IMAGE URL ||============================== //

// export function getImageUrl(name: string, path: string) {
//     return new URL(`/src/assets/images/${path}/${name}`
//         // , process.env.REACT_APP_STATIC_BASE_URL
//     ).href;
// }

export function getImageUrl(name: string, path: string) {
    const baseUrl = process.env.REACT_APP_STATIC_BASE_URL || window.location.origin;

    // Ensure no leading slash on path
    const cleanPath = `src/assets/images/${path}/${name}`.replace(/^\/+/, "");

    try {
        return new URL(cleanPath, baseUrl).href;
    } catch (error) {
        console.error("Invalid URL:", { cleanPath, baseUrl });
        return ""; // Return an empty string or fallback URL
    }
}



///// azure hosted avatars ===============================================

// export enum ImagePath {
//     LANDING = 'landing',
//     USERS = 'users',
//     ECOMMERCE = 'e-commerce',
//     PROFILE = 'profile',
// }

// // ==============================|| NEW URL - GET IMAGE URL ||============================== //
// export async function getImageUrl(name: string, path: string): Promise<string> {
//     try {
//         const response = await fetch('YOUR_AZURE_FUNCTION_URL'); // Replace with your actual Azure Function URL
//         const data = await response.json();

//         const file = data.files.find((file: { fileName: string }) => file.fileName === name);
//         return file ? file.imageUrl : ''; // Return image URL or empty string if not found
//     } catch (error) {
//         console.error('Error fetching image data:', error);
//         return ''; // Return empty string or handle error accordingly
//     }
// }

// // Example usage
// (async () => {
//     const avatar1Url = await getImageUrl("avatar-1.png");
//     console.log(avatar1Url); // Logs the Azure URL for avatar-1.png

//     const localImageUrl = new URL(`/src/assets/images/${ImagePath.LANDING}/image.png`, import.meta.url).href;
//     console.log(localImageUrl); // Logs the local URL for image.png in the landing folder
// })();
